import PageHeader from "../components/layout/PageHeader";
import { BlogCard } from "../components/common/Cards";
import BlogSidebar from "../components/common/BlogSidebar";
import { blogs } from "../data/blog";

export default function BlogGrid() {
  return (
    <>
      <PageHeader title="Our Blog" crumbs={[{ label: "Blog" }]} />
      <section className="section">
        <div className="container single-layout">
          <div>
            <div className="grid grid-2">
              {blogs.map((b) => <BlogCard key={b.id} post={b} />)}
            </div>
          </div>
          <BlogSidebar />
        </div>
      </section>
    </>
  );
}
